"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createImg = exports.createCanvas = exports.sum = exports.square = exports.removeClass = exports.addClass = exports.getRandomNumberByRange = void 0;
var createCanvas_1 = __importDefault(require("./createCanvas"));
exports.createCanvas = createCanvas_1.default;
var createImg_1 = __importDefault(require("./createImg"));
exports.createImg = createImg_1.default;
var utils_1 = require("./utils");
Object.defineProperty(exports, "getRandomNumberByRange", { enumerable: true, get: function () { return utils_1.getRandomNumberByRange; } });
Object.defineProperty(exports, "addClass", { enumerable: true, get: function () { return utils_1.addClass; } });
Object.defineProperty(exports, "removeClass", { enumerable: true, get: function () { return utils_1.removeClass; } });
Object.defineProperty(exports, "square", { enumerable: true, get: function () { return utils_1.square; } });
Object.defineProperty(exports, "sum", { enumerable: true, get: function () { return utils_1.sum; } });
